module.exports = __webpack_public_path__ + "media/images/mid-star-f86a5c86ba09c057bfa970b5089edaa4.png";